import { Component, Inject, type OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  standalone: false,
  selector: 'app-performance-dashboard-linechart',
  templateUrl: './performance-dashboard-linechart.component.html',
  styleUrl: './performance-dashboard-linechart.component.scss'
})
export class PerformanceDashboardLinechartComponent implements OnInit {
  closeModal!: () => void
  title: string = ''

  constructor (
    public dialogRef: MatDialogRef<PerformanceDashboardLinechartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit () {}

  onClose (): void {
    if (this.closeModal) {
      this.closeModal()
    } else {
      this.dialogRef.close()
    }
  }
}
